import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { findUser } from "../services/users.service";
import { CurrentUserResult } from "../interfaces/current-user.interface";
import { ksUserQK } from "../query-keys";

type QueryOptions<T> = Omit<UseQueryOptions<T>, "queryKey" | "queryFn">;

export const useCurrentUser = (options?: QueryOptions<CurrentUserResult>) =>
  useQuery({
    queryKey: [ksUserQK],
    queryFn: findUser,
    ...options,
  });
